import React from "react";
import { MdOutlinePhonelinkSetup } from "react-icons/md";
import { FaWpforms } from "react-icons/fa";
import { RiFlowChart } from "react-icons/ri";
import styles from "./toolkit.module.scss";
import { Grid } from "@mui/material";

const state = [
  {
    id: 1,
    icon: <MdOutlinePhonelinkSetup />,
    title: "Live Chat",
    text: "Answer student queries and follow up on applications through our instant messaging option",
  },
  {
    id: 2,
    icon: <FaWpforms />,
    title: "Centralised Application",
    text: "Receive, review, and update the status of application packages through a single platform",
  },
  {
    id: 3,
    icon: <RiFlowChart />,
    title: "Track Application",
    text: "View in real-time the completion status of applications and follow up for pending or incomplete steps",
  },
];

function RecruiterToolCard({ item, index }) {
  return (
    <div className={styles.card_wrapper}>
      <div>
        <span>{item.icon}</span>
        <h2>{item.title}</h2>
        <p>{item.text}</p>
      </div>
      {index === 2 ? null : <div className={styles.border_right}></div>}
    </div>
  );
}

export const UniPageDiversifyToolkit = () => {
  return (
    <section className={styles.section_toolkit}>
      <div className="container">
        <h2 className={"center"}>Our University Partner Toolkit</h2>
        <p className={"center font-large"}>
          Here are just some of the functionalities at your disposal through the
          UniSearch dashboard
        </p>
        <div className={styles.card_wrapper}>
          <Grid container spacing={0}>
            {state.map((item, index) => (
              <Grid item md={4} xs={12} key={index}>
                <RecruiterToolCard item={item} index={index} />
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </section>
  );
};

export default UniPageDiversifyToolkit;
